import '../../types'

export function safeAssign(newState, state) {
  let allSame = true
  for (const k in newState) {
    const currentProp = Object.getOwnPropertyDescriptor(state, k)
    if (currentProp && currentProp.set) {
      state[k] = newState[k] // combine sets maybe
      allSame = false
      continue
    }
    const newProp = Object.getOwnPropertyDescriptor(newState, k)
    if (newProp.set) { // what if current state has value?
      Object.defineProperty(state, k, newProp)
      allSame = false
      continue
    }
    if (currentProp) {
      const currentValue = state[k]
      const { value: newValue } = newProp
      if (currentValue !== undefined && newValue !== undefined && newValue == currentValue) {
        continue
      }
    }
    state[k] = newState[k]
    allSame = false
    // if (currentProp.value !== undefined && newProp.value !== undefined && newProp)
  }
  return { allSame }
}

/** @type {guest.maurice.getDataIds} */
export const getDataIds = (el) => {
  const children = {}
  try {
    /** @type {!Array<!HTMLElement>} */
    const els = [...el.querySelectorAll('[data-id]')].reverse()
    for (const ch of els) {
      children[ch.dataset['id']] = ch
    }
  } catch (err) {
    return children
  }
  return children
}

/** @type {guest.maurice.delegateState} */
export function delegateState(state, instance) {
  for (const key in state) {
    Object.defineProperty(instance, key, {
      get() {
        return state[key]
      },
      configurable: true,
    })
  }
}

/**
 * @param {function(new: T, ...?): T} Constructor
 * @param {!HTMLElement} el
 * @template T
 * @return {T}
 */
export function createElement(Constructor, el) {
  const ell=Object.create(Constructor.prototype, /** @type {!guest.maurice.IElemental|guest.maurice.IClassified} */ ({
    element: {
      value: el,
      writable: false,
    },
    classList: {
      value: el.classList,
      writable: false,
    },
  }))
  return ell
}